module.exports = __webpack_public_path__ + "img/plate02_06.6484a74d.png";